import { AggregateRating } from "schema-dts"
import { AggregatedReviewData } from "src/data/product-details/types"
import { createLdJsonSchemaId } from "src/seo/linkedDataHelpers"

// https://developers.google.com/search/docs/appearance/structured-data/review-snippet
export function createRatingLd(id: string, rating: AggregatedReviewData) {
  const ld: AggregateRating = {
    // https://schema.org/AggregateRating
    "@type": "AggregateRating",
    "@id": createLdJsonSchemaId("AggregateRating-" + id),
    ratingValue: rating.stars,
    reviewCount: rating.count,
    worstRating: "1",
    bestRating: "5",
  }

  return ld
}
